import { ref, reactive } from "vue";
import { defineStore, storeToRefs } from 'pinia';
import { useAuthStore } from "@/stores/auth";
import NotificacaoService from "@/services/NotificacaoService";

export const useNotificacoesStore = defineStore('notificacoes', () => {
    // AUTH
    const authStore = useAuthStore();

    const { isAuthenticated, notificacoesNaoLidasCount } = storeToRefs(authStore);

    // NOTIFICAÇÕES
    const notificacoes = ref(null);

    // LOADING
    const loading = ref(false);

    // ERRO
    const erro = ref(false);

    // PAGINAÇÃO
    const paginator = reactive({
        first: 0,
        rows: 10,
        page: 0,
        totalRecords: 0
    });

    const getNotificacoes = async ({ page = 0, rows = 10 } = {}) => {
        if (!isAuthenticated.value) return;

        const mesmaPagina = paginator.page === (page + 1) && paginator.rows === rows;

        if (notificacoes.value && mesmaPagina) {
            return {
                current_page: paginator.page,
                per_page: paginator.rows,
                total: paginator.totalRecords,
                data: notificacoes.value
            }
        }

        erro.value = false;
        loading.value = true;

        const params = {
            page: page + 1,
            per_page: rows
        };

        try {
            const { data } = await NotificacaoService.listarTodas(params);

            notificacoes.value = data.data.data;

            handlePagination(data.data);

            return data.data;
        } catch (e) {
            erro.value = true;

            console.error(e);
        } finally {
            loading.value = false;
        }
    }

    const registrarNotificacaoComoLida = async (notificacaoId) => {
        try {
            const { data } = await NotificacaoService.ler(notificacaoId);

            notificacoes.value.map(notificacao => {
                if (notificacao.id === notificacaoId && !notificacao.read_at) {
                    notificacao.read_at = data.data.lido_em;

                    notificacoesNaoLidasCount.value--;
                }
            });
        } catch (e) {
            console.error('Não foi possível registrar notificação como lida!', e);
        }
    }

    const handlePagination = (data) => {
        paginator.page = data.current_page;
        paginator.rows = parseInt(data.per_page);
        paginator.totalRecords = data.total;
    }

    return {
        notificacoes,
        notificacoesNaoLidasCount,
        loading,
        erro,
        paginator,
        getNotificacoes,
        registrarNotificacaoComoLida,
    };
});
